const CopyrightPolicy = () => {
  return (
    <div className="!py-4 text-white">
      <div className="container">
        <div>
          <p
            style={{
              textAlign: 'center',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Copyright Policy</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>
                <br />
                &nbsp;
              </strong>
            </span>
            <span>
              APOLO respects the intellectual property rights of others, and we expect you to do the
              same.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              By using the APOLO Website, You agree that the Website and all Services provided by
              APOLO are the property of APOLO, including all copyrights, trademarks, trade secrets,
              patents, and other intellectual property ("Company IP").&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              You agree that APOLO owns all right, title and interest in and to the Company IP and
              that You will not use the Company IP for any unlawful or infringing purpose. You agree
              not to reproduce or distribute the Company IP in any way, including electronically or
              via registration of any new trademarks, trade names, service marks or Uniform Resource
              Locators (URLs), without express written permission from APOLO.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Copyright</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Copyright is a legal right that protects original works of authorship (e.g., music,
              videos, code etc.). Generally, copyright protects an original expression of an idea
              (e.g., the specific way a video or music is expressed or created) but does not protect
              underlying ideas or facts.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Copyright Infringement</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              We do not allow any content that infringes copyright. The use of copyrighted content
              of others without proper authorization or legally valid reason may lead to a violation
              of APOLO's policies.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              At the same time, not all unauthorized uses of copyrighted content constitute an
              infringement. Exceptions to copyright infringement, such as the fair use doctrine or
              other applicable laws, allow use of copyrighted work under certain circumstances.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Suspension or Termination of Account</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Any user content that infringes other person’s copyright may be removed. The account
              may be suspended or terminated for multiple copyright violations in connection with
              the use of the APOLO site or app, or other violations of the{' '}
              <a href="https://www.tiktok.com/en/terms-of-use" target="_blank" rel="noreferrer">
                Terms of Service
              </a>{' '}
              . We reserve the right to refuse any account holder whose account was used for
              improper activities from opening a new account on APOLO’s site or app, or otherwise
              hosted by APOLO.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Copyright Infringement Notification</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              If you are a copyright owner, authorized to act on behalf of one, or authorized to act
              under any exclusive right under copyright, please report alleged copyright
              infringements taking place on or through the Site by completing a DMCA Notice of
              Alleged Infringement and delivering it to us. Upon receipt of Notice as described
              below, Company will take whatever action, in its sole discretion, it deems
              appropriate, including removal of the challenged content from the Site.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              •Identify the copyrighted work that you claim has been infringed, or - if multiple
              copyrighted works are covered by your Notice - you may provide a representative list
              of the copyrighted works that you claim have been infringed.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              •Identify the material or link you claim is infringing (or the subject of infringing
              activity) and to which access is to be disabled, including at a minimum, if
              applicable, the URL of the link shown on the Site or the exact location where such
              material may be found.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              •Provide your company affiliation (if applicable), mailing address, telephone number,
              and, if available, email address.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>•Include both of the following statements in the body of the Notice:</span>
          </p>
          <ul>
            <li>
              <p
                style={{
                  textAlign: 'justify',
                  background: 'transparent',
                  lineHeight: '100%',
                  marginTop: '0.17in',
                  marginBottom: '0.17in',
                }}
              >
                <span>
                  "I hereby state that I have a good faith belief that the disputed use of the
                  copyrighted material is not authorized by the copyright owner, its agent, or the
                  law (e.g., as a fair use)."
                </span>
              </p>
            </li>
            <li>
              <p
                style={{
                  textAlign: 'justify',
                  background: 'transparent',
                  lineHeight: '100%',
                  marginTop: '0.17in',
                  marginBottom: '0.17in',
                }}
              >
                <span>
                  "I hereby state that the information in this Notice is accurate and, under penalty
                  of perjury, that I am the owner, or authorized to act on behalf of, the owner, of
                  the copyright or of an exclusive right under the copyright that is allegedly
                  infringed."
                </span>
              </p>
            </li>
          </ul>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>•Provide your full legal name and your electronic or physical signature.</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>•Deliver this Notice, with all items completed, to us by e-mail.</span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Failure to include necessary information may limit our ability to investigate your
              claims and may result in your complaint being denied.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              We may provide the account holder with your contact information, including the email
              address and the name of the copyright owner, and/or details of the complaint.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Before submitting a notification, please be aware that intentionally submitting a
              misleading or fraudulent report may lead to liability for damages under section 512(f)
              of the United States Digital Millennium Copyright Act (DMCA) or similar laws as may be
              applicable in other countries.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Copyright Infringement Counter-Notification</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              If you receive a copyright infringement notification that you believe to be in error
              or believe that you are authorised to use the content, you can reach out to the
              copyright owner directly to request a retraction.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              The counter-notification process will take time to complete, please be patient. During
              this time, the copyright claimant may file an action seeking a court order to keep the
              content down in pursuant to the United States Digital Millennium Copyright Act (DMCA)
              or similar laws in other countries. Please note that we will forward the entire
              counter-notification to the original reporter, including any contact information you
              provide, in accordance with our Terms of Services and Privacy Policy. The claimant may
              use this information to file a lawsuit against you.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              If we do not receive notice that the original reporter is seeking a court order to
              prevent further infringement of the material at issue, we may replace or cease
              disabling access to the material that was removed if the material does not infringe on
              third-party copyright. The decision to re-post any material is at APOLO’s sole
              discretion.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Trademark</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              A trademark is a word, symbol, slogan, design, or combination of any of the foregoing
              that identifies the source of a product or service and distinguishes it from other
              products or services.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Trademark Infringement</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Trademark laws prohibit trademark infringement, which is generally the unauthorized
              use of a trademark or service mark in connection with goods or services in a way that
              is likely to cause confusion, deception or mistake about the source, origin,
              sponsorship or affiliation of the associated goods and/or services.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              At the same time, the use of another’s trademark for purposes of accurately
              referencing, lawfully commenting, criticizing, parodying, or reviewing the trademark
              owner’s products or services, or for purposes of comparing them to other products or
              services, where the mark is not used to designate the user’s own goods or services or
              those of a third party, is generally not considered a violation of our policies.
              Likewise, it is generally permissible to make a fan page about a brand, even without
              the brand’s permission, provided that you do not claim to speak for or be associated
              with the brand or otherwise violate the brand’s intellectual property rights.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Removal of Content; Suspension or Termination of Account</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Any content that violate another’s trademark rights may be taken down. Repeat
              violations of trademark rights in connection with the use of the APOLO site or app, or
              other violations of the{' '}
              <a href="https://www.tiktok.com/en/terms-of-use" target="_blank" rel="noreferrer">
                Terms of Service
              </a>{' '}
              and{' '}
              <a
                href="https://www.tiktok.com/community-guidelines"
                target="_blank"
                rel="noreferrer"
              >
                Community Guidelines
              </a>{' '}
              may result in the suspension or termination of the user account. We reserve the right
              to refuse any account holder whose account was used for improper activities from
              opening a new account on APOLO’s site or app, or otherwise hosted by APOLO.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Trademark Complaint and Notification</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Contacting the user directly may resolve your complaint more quickly and in a way that
              is more beneficial to you, the user, and our community. You may also file a{' '}
              <a
                href="https://www.tiktok.com/legal/report/Trademark"
                target="_blank"
                rel="noreferrer"
              >
                Trademark Infringement Report
              </a>
              .
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              All complaints should contain the information requested in our online Trademark
              Infringement Report form. &nbsp;Failure to include necessary information may limit our
              ability to deal with your claims and may result in your complaint being denied. We may
              provide the account holder with your contact information, including the email address
              and the name of the trademark owner, and/or details of the complaint, in accordance
              with our Terms of Services and Privacy Policy.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              Before submitting a notification, please be aware that intentionally submitting a
              misleading or fraudulent report may lead to liability for damages under laws as may be
              applicable in some countries.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>Trademark Infringement Counter-Notification</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              If you receive a trademark infringement notification that you believe to be in error
              or believe that you are authorized to use the content, you can reach out to the
              trademark owner directly to request a retraction.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              You may also provide us with a counter-notification via our online{' '}
              <a
                href="https://www.tiktok.com/legal/report/counternotification"
                target="_blank"
                rel="noreferrer"
              >
                Counter Notification Form
              </a>
              . All counter-notification should contain the information requested in our online
              Counter Notification Form. Failure to include necessary information may limit our
              ability to investigate your claims and may result in your counter-notification being
              denied.&nbsp;
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              <strong>General Note:</strong>
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              As an APOLO user, you are responsible for the content you post. If you have questions
              about copyright law or trademark law, such as questions about whether your content or
              your use of another person’s name or brand infringes or otherwise violates another
              person’s rights, you may want to contact an attorney. If you are unsure whether the
              material you plan to report to us is infringing or otherwise violating another
              person’s right, you may also want to first seek legal advice before reporting such
              content to us.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <span>
              If you submit a report or infringement notification to us, we may contact you if we
              have additional questions about your report or notification. Please note that APOLO is
              not in a position to adjudicate disputes between third parties, and may not be able to
              remove the content or suspend the account you reported. As an alternative, you may
              want to contact the person who posted the content or owns the account to try to
              resolve your issue directly.
            </span>
          </p>
          <p
            style={{
              textAlign: 'justify',
              background: 'transparent',
              lineHeight: '100%',
              marginTop: '0.17in',
              marginBottom: '0.17in',
            }}
          >
            <br />
            &nbsp;
          </p>
          <p style={{ lineHeight: '100%', textAlign: 'left', marginBottom: '0in' }}>
            <br />
          </p>
        </div>
      </div>
    </div>
  )
}

export default CopyrightPolicy
